module.exports = __webpack_public_path__ + "static/IMG-20251103-092344-956f43f27765e58bbf947f795930161c.jpg";